import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useSettings } from '../src/contexts/SettingsContext';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations';

/**
 * Предупреждение гостю, что сервис работает в бета-версии.
 *
 * Не закрывается: это не уведомление, а состояние сервиса. Человек должен
 * видеть его и в тот момент, когда решает оформить заказ.
 *
 * Заказы при этом самые обычные — готовятся и считаются в выручке, ничем от
 * остальных не отличаются. Баннер только предупреждает и извиняется за
 * возможные сбои, а не помечает заказ как ненастоящий.
 */
const BetaBanner: React.FC = () => {
  const { settings } = useSettings();
  const { language } = useLanguage();

  if (!settings.betaMode) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-[60] flex items-start gap-2.5 px-4 py-2.5 bg-[var(--color-warning-bg)] border-b border-warning text-[var(--beta-banner-fg)]"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
      <div className="min-w-0">
        <p className="text-xs font-black uppercase tracking-wider leading-tight">
          {t('common.betaBanner', language)}
        </p>
        <p className="text-[11px] font-bold leading-tight mt-0.5">
          {t('common.betaBannerHint', language)}
        </p>
      </div>
    </div>
  );
};

export default BetaBanner;
